import React from "react";

function CardWrap({ style, wrapStyle, children }) {
	return (
		<div className="card" style={style}>
			<div className="card wrap" style={wrapStyle}>
				{children}
			</div>
		</div>
	);
}

export default CardWrap;
